// import { scan } from 'react-scan';
import './utils/legacySafariCompatibility';
import React from 'react';
import ReactDOM from 'react-dom/client';
import Interface from './Components/Interface';
import { PostHogProvider } from 'posthog-js/react';
import ErrorBoundary from './Components/ErrorBoundary';
import { createPosthogOptions } from './utils/posthogOptions';
import { applyDemoSeo } from './utils/demoSeo';
import { loadClarity } from './utils/clarity';
import { getSubdomain } from './utils/utils';

// if (typeof window !== 'undefined') {
//     scan({
//       enabled: true,
//       log: true, // logs render info to console (default: false)
//     });
//   }

const options = createPosthogOptions(process.env.REACT_APP_POSTHOG_KEY);

applyDemoSeo(document, window.location.hostname);
loadClarity(process.env.REACT_APP_CLARITY_ID, getSubdomain());

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <PostHogProvider apiKey={process.env.REACT_APP_POSTHOG_KEY} options={options}>
    <ErrorBoundary>
      <Interface />
    </ErrorBoundary>
  </PostHogProvider>
);
